"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable camelcase */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
// NOTE: this facility is no longer active.
exports.concentrationLimitPointerMethods = [
    // any single receivable cannot be more than 20%
    {
        method: 'rainSoundPoint1.singleReceivableLimit',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit singleReceivableLimit`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const standardBorrowingBaseReductions = _.map(concentrationReceivables, (receivable) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: [receivable],
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = { ...result };
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map